/* @flow */
import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';

export class TextInput extends React.Component {
  render() {
    const {
      field,
      placeholder,
      children,
      maxLength,
      isInlineElement,
      ariaLabelledBy,
      ariaDescribedBy,
      onKeyPress,
      qaTag,
      disabled,
      ariaLabel,
      style,
    } = this.props;

    const isInvalid = this.props.field.meta.invalid && this.props.field.meta.touched
    const inputClasses = classNames({
      'inline-element': isInlineElement,
      'form-group': this.props.formGroup !== undefined ? this.props.formGroup : true,
      'has-error is-invalid': isInvalid,
    });
    const isInvalidClass = isInvalid ? 'is-invalid' : '';
   
    const type = this.props.type || 'text';

    let onChangeFunction = field.input.onChange;
    if (this.props.onChange) {
      onChangeFunction = (event) => {
        field.input.onChange(event);
        this.props.onChange(event);
      };
    }
    
    const inputAttributes = {
      type,
      className: 'form-control form-control-ie ' + isInvalidClass,
      placeholder,
      maxLength,
      id: field.input.name,
      name: field.input.name,
      value: this.props.value ? this.props.value : field.input.value,
      onChange: onChangeFunction,
      onKeyPress,
      'aria-labelledby': ariaLabelledBy,
      'data-qa-item': qaTag,
      disabled,
      'aria-label': ariaLabel,
      style: style,
    };


    if (this.props.hasHelpText) {
      inputAttributes['aria-describedby'] = ariaDescribedBy;
    }

    return (
      <div className={inputClasses}>
      <input
        {...inputAttributes}
      />
      { children }
      </div>
    );
  }
}

TextInput.propTypes = {
  field: PropTypes.object.isRequired,
  children: PropTypes.object,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  maxLength: PropTypes.number,
  isInlineElement: PropTypes.bool,
  onKeyPress: PropTypes.func,
  ariaLabelledBy: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  qaTag: PropTypes.string,
  formGroup: PropTypes.bool,
  hasHelpText: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  ariaLabel: PropTypes.string,
  style: PropTypes.object,
};
